import React from "react"

import * as Geo from "@/base/geo"
import { Polyline as BasePolyline } from "@react-google-maps/api"

import type { PolylineProps } from "@react-google-maps/api"
import type { ArrowLineProps } from "./makeUseDirectionArrow"
import { makeUseDirectionArrow } from "./makeUseDirectionArrow"

const useDirectionArrow = makeUseDirectionArrow(Geo.pointToGmaps)

function ArrowSegmentWeb({
  path,
  strokeColor,
}: Pick<PolylineProps, "path"> & {
  strokeColor?: string
}) {
  return (
    <BasePolyline
      path={path}
      options={{
        strokeColor: strokeColor ?? "orange",
        strokeWeight: 3,
        zIndex: 4,
      }}
    />
  )
}
export function ArrowBaseWeb(props: {
  arrowLineLeft: google.maps.LatLngLiteral[] | undefined
  arrowLineRight: google.maps.LatLngLiteral[] | undefined
  mainLine: google.maps.LatLngLiteral[] | undefined
  strokeColor?: string
}) {
  if (props.arrowLineLeft && props.arrowLineRight && props.mainLine) {
    return (
      <React.Fragment>
        <ArrowSegmentWeb
          path={props.arrowLineLeft}
          strokeColor={props.strokeColor}
        />
        <ArrowSegmentWeb
          path={props.arrowLineRight}
          strokeColor={props.strokeColor}
        />
        <ArrowSegmentWeb
          path={props.mainLine}
          strokeColor={props.strokeColor}
        />
      </React.Fragment>
    )
  }
  return null
}

/**
 * Display directional arrow on the map
 */
export function ArrowWeb({
  strokeColor,
  ...rest
}: ArrowLineProps & {
  strokeColor?: string
}): React.JSX.Element | null {
  const arrow = useDirectionArrow(rest)
  if (arrow) {
    return <ArrowBaseWeb strokeColor={strokeColor} {...arrow} />
  }
  return null
}
